import React from "react";
import "./logo-mark-loader.css";

/**
 * June logo mark loader. The dot and two bars flip in sequence.
 */
const LogoMarkLoader = ({ className = "", label = "Loading" }) => (
  <div className={`logo-mark-loader ${className}`.trim()} role="status" aria-label={label}>
    <div className="logo-mark-loader__stage">
      <div className="logo-mark-loader__el logo-mark-loader__dot" />
      <div className="logo-mark-loader__el logo-mark-loader__bar-tall" />
      <div className="logo-mark-loader__el logo-mark-loader__bar-short" />
    </div>
  </div>
);

export default LogoMarkLoader;
